window.app.directive("msApplication", [
  function() {
    return {
      restrict: "E",
      scope: false,
      transclude: true,
      template: (tElement, tAttrs) => {
        tElement.html(require("./index.html"));
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/apps/shared/application/index.js